import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AuthService } from './../../../../services/auth.service';

import Swal from 'sweetalert2'


@Component({
  selector: 'app-mgtrequest',
  templateUrl: './mgtrequest.component.html',
  styleUrls: ['./mgtrequest.component.css'],
  animations: [
    trigger('ShowHide', [
      state('spinning', style({ opacity: 1 })),
      state('stopped', style({ opacity: 0, display: 'none' })),
      transition('spinning => stopped', [animate('300ms')]),
      transition('stopped => spinning', [animate('300ms')]),

    ]),
  ]
})
export class MGTRequestComponent implements OnInit {

  COMP_NAME: any = '';
  F_NAME: any = '';
  L_NAME: any = '';
  EMAIL_ID: any = '';
  OTP: any = '';
  COMP_NUMBER: any = '';
  loaderspinning: boolean = false;
  ShowOTPForm: boolean = false;
  ORG_OTP: any = '';

  ModalData:any='';


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _mdr: MatDialogRef<MGTRequestComponent>,
    private toastr: ToastrService,
    private AuthServ: AuthService
  ) { 
    this.ModalData = data.DocName;
  }

  ngOnInit(): void {

  }

  Close() {
    this._mdr.close(false)
  }

  SubmitDetails() {

    if (!this.COMP_NAME) {
      this.toastr.warning("Enter Company Name");
      return;
    }
    if (!this.F_NAME) {
      this.toastr.warning("Enter First Name");
      return;
    }
    if (!this.COMP_NUMBER) {
      this.toastr.warning("Enter Mob. Vumber");
      return;
    }
    if (!this.EMAIL_ID) {
      this.toastr.warning("Enter Mail");
      return;
    }


    this.loaderspinning = true;
    let sendObj = {
      COMP_NAME: this.COMP_NAME,
      F_NAME: this.F_NAME,
      L_NAME: this.L_NAME,
      EMAIL_ID: this.EMAIL_ID,
      COMP_NUMBER: this.COMP_NUMBER
    }
    this.AuthServ.VerifyMail(sendObj).subscribe((Res) => {
      this.loaderspinning = false;
      try {
        if (Res.success == true) {
          Swal.fire({
            title: "An OTP has been sent to your account. Please verify it to complete the process.",
            icon: "success",
            cancelButtonText: "No",
            showCancelButton: true,
            confirmButtonText: "Yes"
          }).then(result => {
            if (result.value) {
              this.ShowOTPForm = true;
              this.ORG_OTP = Res.data;

            } else {
              this.ShowOTPForm = false;

            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'OTP not send. Please Contact system administrator.',
            showConfirmButton: true,
            timer: 2500
          })
        }
      } catch (error) {
        this.toastr.error(error)
      }
    })
  }


  public decrypt (salt, encoded) {
    const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
    const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
    return encoded
      .match(/.{1,2}/g)
      .map((hex) => parseInt(hex, 16))
      .map(applySaltToChar)
      .map((charCode) => String.fromCharCode(charCode))
      .join("");
  };

  VerifyOTP() {
    if(!this.OTP){
      this.toastr.warning("Enter OTP.");
      return
    }
    const decrypted_string = this.decrypt("N@r0l@Gem$CRM", this.ORG_OTP);
    if(this.OTP != decrypted_string){
      this.toastr.warning("Please enter valid OPT !!!");
      return
    }else{

      let sendObj = {
        COMP_NAME: this.COMP_NAME,
        F_NAME: this.F_NAME,
        L_NAME: this.L_NAME,
        EMAIL_ID: this.EMAIL_ID,
        COMP_NUMBER: this.COMP_NUMBER,
        DOC_NAME: this.ModalData
      }

      this.loaderspinning = true;
      this.AuthServ.DocumentMail(sendObj).subscribe((Res) => {
        this.loaderspinning = false
        try {
          if(Res.success == true){

            Swal.fire({
              title: "Your request has been successfully submitted. We will get back to you within 24 working hours.",
              icon: "success",
              cancelButtonText: "No",
              showCancelButton: true,
              confirmButtonText: "Yes"
            }).then(result => {
              if (result.value) {
                this._mdr.close();
              } else {
                this._mdr.close();
              }
            })

          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Request not send. Please Contact system administrator.',
            showConfirmButton: true,
            timer: 2500
          });
        }
      })
      
    }

  }
}
